import React, { useState } from 'react';
import { Box, Button, CircularProgress, Grid, Paper, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { AuthPageStyles } from '../../authentication/styles';
import { ReactComponent as ReAttemptIcon } from '../images/reAttempt.svg';
import { useTranslation } from 'react-i18next';
import { logoutUser } from '../utils/logoutUser';
import { useHistory } from 'react-router-dom';
import { routeMappings } from '../../constants';
import ReAttemptStyles from '../styles/reAttempt';
import StageCompletionStyles from '../../staticPages/styles/stageCompletion';
import { useAppSelector } from '../../redux-store/hook';

export const ReAttemptPage = (): JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { settings } = useAppSelector((state) => state.template);
  const candidate = useAppSelector((state) => state.candidate);
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const { isICPEnabled } = useAppSelector((state) => state.headerDetails);
  const classes = AuthPageStyles({ isICPEnabled: isICPEnabled });
  const reAttemptClasses = ReAttemptStyles(settings);
  const stageCompletionClasses = StageCompletionStyles(settings);

  const history = useHistory();

  const [loading, setLoading] = useState<boolean>(false);

  const signOut = async (): Promise<void> => {
    setLoading(true);
    const res = await logoutUser(candidate);
    if (res.data && res.data.Success) {
      history.push(routeMappings['LOGIN']);
    }
    setLoading(true);
  };

  return (
    <Grid container justify="center" className={classes.container}>
      <Grid item xl={8} lg={10} className={classes.grid}>
        <Paper elevation={lgUp ? 1 : 0} className={classes.paper}>
          <Box textAlign="center">
            <Box>
              <ReAttemptIcon width="120px" height="120px" className={stageCompletionClasses.staticPageIcon} />
              <Typography variant="h2" className={reAttemptClasses.reAttemptHeading}>
                {t('reAttemptHeading')}
              </Typography>
            </Box>
            <Box>
              <Box className={reAttemptClasses.reAttemptText}>
                <Typography variant="body1">{t('reAttemptMessage1')}</Typography>
              </Box>
              <Box className={reAttemptClasses.reAttemptText}>
                <Typography variant="body1">{t('reAttemptMessage2')}</Typography>
              </Box>
            </Box>
          </Box>
          {/** button for sign in */}
          <Grid item xs={12}>
            <Box width="100%" textAlign="center">
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                disabled={loading}
                aria-hidden={loading}
                aria-disabled="false"
                onClick={signOut}>
                <div>{t('signout')}</div>
                {loading && <CircularProgress size={25} className={classes.buttonProgress} />}
              </Button>
            </Box>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};
